import React, { useState } from 'react';
import { fetchUsers } from '../../services/General/citaServiceGraph'
import { citaUser } from '../../types/citaUser';

interface UserSearchProps {
    onUserSelect?: (user: citaUser) => void; // Callback para manejar la selección del usuario
}

// Frontend: Componente de búsqueda
const UserSearch = ({ onUserSelect }: UserSearchProps) => {
    const [query, setQuery] = useState('');
    const [users, setUsers] = useState<citaUser[]>([]);
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const searchUsers = async (searchTerm: string) => {
        if (searchTerm.length < 3) {
            setUsers([]);
            return;
        }

        const usersResponse = await fetchUsers(searchTerm);
        setUsers(usersResponse);
    };

    return (
        <div className="position-relatve">
            {/* <label htmlFor="userSearch" className="form-label me-2">Buscar Anfitrion: </label> */}
            <input
                type="text"
                className='mb-3 form-control form-control-sm'
                placeholder='Buscar por nombre o correo...'
                id='userSearch'
                autoComplete='off'
                value={query}
                onChange={(e) => {
                    setQuery(e.target.value);
                    searchUsers(e.target.value);
                }}
                onFocus={() => setIsOpen(true)}
                onBlur={() => setTimeout(() => setIsOpen(false), 200)}
                style={{ width: '100%' }}
            />
            {isOpen && (
                <div className="dropdown-menu show w-100 overflow-auto" style={{ maxHeight: '300px' }}>
                    <ul className="list-group" style={{ maxHeight: '250px' }}>
                        {users.length > 0 ? (
                            users.map((user: any, index: number) => (
                                <button
                                    type='button'
                                    key={index}
                                    className='dropdown-item text-start'
                                    style={{ cursor: 'pointer' }}
                                    onMouseDown={() => {
                                        console.log(user)
                                        onUserSelect?.(user); // Llama al callback con el usuario seleccionado
                                        setQuery(user.mail); // Actualiza el campo de búsqueda con el nombre del usuario seleccionado
                                    }}
                                >
                                    {user.displayName} - {user.mail}
                                </button>
                            ))
                        ) : (
                            <li className="list-group-item">No se encontraron resultados</li>
                        )}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default UserSearch;